import isEmpty from "../../util/isEmpty";

export const checkIfProfileIdNotEmpty = (history, profileId) => {
  if (isEmpty(profileId)) {
    localStorage.removeItem("wedmToken");
    history.push("/signin");
    return false;
  }
};
